import React, { useEffect } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useIncomeSummaryModel } from "../incomeSummaryModel";
import { IIncomeSummaryDetail } from "../incomeSummaryService";
import { formatNum, momentFormat } from "@/utils/utils";
import { useDictModel } from "@/views/base/dict/dictModel";
import YhTootip from "@/components/YhTootip";

export function IncomeDetailsDataTable() {
    const {
        pgCfg,
        incomeDetailsDataSource,
        incomeDetailLoadData
    } = useIncomeSummaryModel();
    const { getTreeNodeName } = useDictModel();

    useEffect(() => {
        incomeDetailLoadData();
    }, [])

    const columns: ColumnsType<IIncomeSummaryDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            align: "center",
            render: (t, r, i) => i + 1,
        }, {
            title: '单据编号',
            width: 120,
            dataIndex: 'documentNumber',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '单据日期',
            width: 140,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        }, {
            title: '单据性质',
            width: 120,
            dataIndex: 'tradeTypeName',
        }, {
            title: '客户名称',
            width: 150,
            dataIndex: 'customerName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '费用信息',
            align: "center",
            children: [
                {
                    title: '工时费',
                    width: 140,
                    align: "center",
                    dataIndex: 'workingHoursAmount',
                    render: (text) => `￥${formatNum(text)}`
                },
                {
                    title: '零件费',
                    width: 140,
                    align: "center",
                    dataIndex: 'materialScienceAmount',
                    render: (text) => `￥${formatNum(text)}`
                },
            ]
        }, {
            title: '结算信息',
            align: "center",
            children: [
                {
                    title: '优惠',
                    width: 140,
                    align: "center",
                    dataIndex: 'discountTotalAmount',
                    render: (text) => `￥${formatNum(text)}`
                },
                {
                    title: '去零',
                    width: 140,
                    align: "center",
                    dataIndex: 'favorableAmount',
                    render: (text) => `￥${formatNum(text)}`
                },
            ]
        }, {
            title: '结算金额',
            width: 120,
            dataIndex: 'totalAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '结算方式',
            width: 120,
            dataIndex: 'payType',
            render: (text) => getTreeNodeName(text)
        }, {
            title: '实收金额',
            width: 120,
            dataIndex: 'paidAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '支付状态',
            width: 120,
            dataIndex: 'payStatus',
            render: (text) => getTreeNodeName(text)
        }, {
            title: '操作员',
            width: 120,
            dataIndex: 'createUser',
        }
    ];


    return (
        <Table
            bordered
            rowKey={record => record.id}
            columns={columns}
            dataSource={incomeDetailsDataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    incomeDetailLoadData({ pageNum, pageSize })
                }
            }}
            scroll={{ x: 'max-content', y: "calc(100vh - 452px)" }
            }
        />
    )
}